import { useGetWaterDropDetailsQuery } from '__gql-generated__/types'
import useUserLeagueInfo from 'utils/hooks/use-user-league-info'

export const useStoryTreeGamification = () => {
  const { data } = useGetWaterDropDetailsQuery()
  const { pointsToShow } = useUserLeagueInfo()

  const forest = data?.me?.reader?.forest
  const coins = Number(forest?.coins ?? 0)
  const drops = Number(forest?.waterDropDetails?.currentDrops ?? 0)

  return {
    coins,
    drops,
    lexileScore: Number(pointsToShow ?? 0)
  }
}
